<template>
  <div>
    <span>Territory</span>
    <multiselect
      v-model="selected"
      :options="options"
      placeholder="Type to search"
      track-by="name"
      label="name"
      :max-height="125"
      :allow-empty="false"
      :multiple="isMultiple"

      :disabled="isDisable"
      :select-label="''"
      deselect-label=""
      :searchable="isSearchable"
      :custom-label="customLabel"
    >
      <span slot="noResult">Oops! No data found</span>
      <template slot="singleLabel" slot-scope="props">
        <span class="option__desc">
          <span class="option__title"
            >{{ props.option.code }} {{ props.option.name }}</span
          >
        </span>
      </template>

      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span class="option__title"
            >{{ props.option.code }} {{ props.option.name }}</span
          >
        </div>
      </template>
    </multiselect>
  </div>
</template>
<script>
export default {
  props: {
    isDisable: {
      type: Boolean,
      default: false,
    },
    isGetData: {
      type: Boolean,
      default: true,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    isSearchable: {
      type: Boolean,
      default: true,
    },
    showAllLabel: {
      type: Boolean,
      default: false,
    },
    params:null,
  },
  data() {
    return {
      baseUrl: "/api/oms/v1/setting-user/territory-master",
      options: [],
      selected: null,
    };
  },
  methods: {
    customLabel(option) {
      console.log("option-custom label", option);
      return `${option.code} - ${option.name}`;
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl, {
          params: {
            order: "code",
            sort: "asc",
            type: "Sales",
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            var options = [];
            options.push({
              id: 0,
              name: "All",
              code: "All",
            });
            this.selected = options[0];
            resp.data.records.forEach(function (item) {
              options.push(item);
            }, options);
            this.options = options;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
    async setSelectedData(data) {
      this.selected = data;
    },
  },
  watch: {
    selected(v) {
      this.selected = v;
      if (this.isMultiple) {
        if (Array.isArray(v)) {
          this.$emit("data", v);
        } else {
          var temp = [];
          temp.push(v);
          this.$emit("data", temp);
        }
      } else {
        this.$emit("data", v.id, v.code);
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
